export type Space = {
	readonly name: string;
	readonly key: string;
};

export const BlueprintCompleteKey = {
	BLANK_SPACE:
		'com.atlassian.confluence.plugins.confluence-create-content-plugin:create-blank-space-blueprint',
} as const;

export type BlueprintCompleteKey = (typeof BlueprintCompleteKey)[keyof typeof BlueprintCompleteKey];

export interface BlueprintData {
	blueprintCompleteKey: BlueprintCompleteKey;
	blueprintModuleCompleteKey: string;
	contentBlueprintId: string;
}

export interface CreateSpaceRequestParams {
	spaceName: string; // eg, 'Knowledge base'
	spaceKey: string; // eg, KB1, LEGAL2, etc.
	spaceBlueprintId: string; // eg, '52c190a9-fe00-4cb7-9bd0-93f992012081',
}

export interface CreatedSpace {
	id: string | null;
	key: string | null;
	name: string | null;
	description: string | null;
	url: string | null;
	draftId?: string | null;
	templateId?: string | null;
	spaceType?: string | null;
}

/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */
export const MediaType = {
	JSON: 'application/json',
	X_WWW_FORM_URLENCODED: 'application/x-www-form-urlencoded',
} as const;

export type MediaType = (typeof MediaType)[keyof typeof MediaType];
